import {
  NAME_REGEX,
  EMAIL_REGEX,
  MOBILE_REGEX,
} from './validationRules';

export const required = value => value ? undefined : 'Required';

export const name = value => {
  return value && !NAME_REGEX.test(value) ? `Invalid Name` : undefined;
}

export const email = value => {
  return value && !EMAIL_REGEX.test(value) ? `Invalid Email` : undefined;
}

export const mobile = value => {
  return value && !MOBILE_REGEX.test(value) ? `Invalid Mobile` : undefined;
}




// WEBPACK FOOTER //
// ./src/utilities/fieldValidate.js